import { useContext, useEffect, useState } from "react";
import { Context } from "../context/Context";
import { GetCreditStatusUser } from "../api/api";
import PaymentAmountModal from "./modals/PaymentAmountModal";
import TransactionsModal from "./modals/TransactionsModal";

const Profile = () => {
  const { authUser, handlePaymentAmountModal, handleTransactionsModal } = useContext(Context);
  const [userCredit, setUserCredit] = useState("");

  useEffect(() => {
    let loc = window.location.pathname;
    if (loc == "/profile") {
      if(authUser.phone_number.startsWith("9")){
        GetCreditStatusUser().then(({ data }) => {
          setUserCredit(data.credit);
        });
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("get_notification_status");
    window.location.reload();
  };


  return (
    <>
      <div className="profile">
        <div className="d-flex align-items-center flex-column">
          <img
            className="img-fluid rounded my-4"
            src="/assets/img/elements/user-128-1.png"
            height="110"
            width="110"
            alt="User avatar"
          />
          <div className="user-info text-center">
            <h5 className="mb-2">{authUser.mobile}</h5>
            {authUser.phone_number.startsWith("9") ? (
              <div>
                <h6 className="mb-2">
                  اعتبار کیف پول:{" "}
                  <span style={{ color: "#00a594" }}>
                    {userCredit !== "" ? (
                      userCredit
                    ) : (
                      <div
                        className="spinner-border spinner-border-sm text-success-app"
                        role="status"
                      >
                        <span className="visually-hidden">
                          در حال بارگذاری ...
                        </span>
                      </div>
                    )}
                  </span>{" "}
                  تومان
                </h6>
                
                <h6
                  className="text-success-app"
                  style={{ cursor: "pointer" }}
                  onClick={handlePaymentAmountModal}
                >
                  <span className="tf-icons bx bx-wallet me-1"></span>
                  شارژ کیف پول
                </h6>

                {/* گزینه لیست تراکنش‌ها */}
                <h6
                  className="text-success-app mt-2"
                  style={{ cursor: "pointer" }}
                  onClick={handleTransactionsModal}
                >
                  <span className="tf-icons bx bx-history me-1"></span>
                  لیست تراکنش‌ها
                </h6>
              </div>
            ) : null}
          </div>
          <div className="text-center">
            <button
              type="button"
              className="btn btn-success-app mt-4"
              onClick={handleLogout}
            >
              خروج
            </button>
          </div>
        </div>
      </div>
      
      <PaymentAmountModal />
      <TransactionsModal />
    </>
  );
};

export default Profile;